'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sourceMap = {
  yelp: 'https://s3-media3.fl.yelpcdn.com/assets/srv0/styleguide/24e1fe240f00/assets/img/brand_guidelines/yelp_fullcolor_outline.png'
};

// const truncateContent = (content) => {
//   if (content.length <= 150) {
//     return content
//   } else {
//     let substr = content.slice(0, 150);
//     let lastWhiteSpace = substr.lastIndexOf(" ");
//     return substr.slice(0, lastWhiteSpace) + "..."
//   }
// };

var ReviewCard = function ReviewCard(_ref) {
  var content = _ref.content,
      _ref$reviewURL = _ref.reviewURL,
      reviewURL = _ref$reviewURL === undefined ? '' : _ref$reviewURL,
      _ref$reviewPageURL = _ref.reviewPageURL,
      reviewPageURL = _ref$reviewPageURL === undefined ? '' : _ref$reviewPageURL,
      source = _ref.source;
  return _react2.default.createElement(
    'div',
    { className: 'review-card' },
    _react2.default.createElement(
      'div',
      { className: 'review-card-inner-container' },
      _react2.default.createElement(
        'div',
        { className: 'review-card-content' },
        content
      ),
      _react2.default.createElement(
        'div',
        { className: 'review-card-details' },
        _react2.default.createElement(
          'div',
          { className: 'review-card-company-image' },
          _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener', href: reviewPageURL },
            _react2.default.createElement('div', { className: 'review-card-logo', style: { backgroundImage: 'url(' + sourceMap[source] + ')' } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'review-card-see-more-btn-container' },
          _react2.default.createElement(
            'div',
            { className: 'review-card-see-more-btn' },
            _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener', href: reviewURL },
              _react2.default.createElement(
                'button',
                null,
                'Read More...'
              )
            )
          )
        )
      )
    )
  );
};

exports.default = ReviewCard;